module.exports = __webpack_public_path__ + "assets/Track-Download.46ddabf9.svg";